import { forkJoin, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { QueryParamsModel } from '../../_base/crud';
import { CompanyNotificationService } from '../../../notification/services/company-notification.service';
import { AppState } from '../../reducers';
import {
  CompanyNotificationActionToggleLoading,
  CompanyNotificationActionTypes,
  CompanyNotificationsPageCancelled,
  CompanyNotificationsPageLoaded,
  CompanyNotificationsPageRequested,
  CompanyNotificationsPageToggleLoading,
  ThrowCompanyNotificationError,
} from '../_actions/company-notification.actions';
import { Router } from '@angular/router';
import { AuthService } from '../../auth/_services/auth.service';

@Injectable()
export class CompanyNotificationEffects {
  showPageLoadingDispatcher = new CompanyNotificationsPageToggleLoading({ isLoading: true });
  showActionLoadingDispatcher = new CompanyNotificationActionToggleLoading({ isLoading: true });
  hideActionLoadingDispatcher = new CompanyNotificationActionToggleLoading({ isLoading: false });

  @Effect()
  loadCompanyNotificationsPage$ = this.actions$.pipe(
    ofType<CompanyNotificationsPageRequested>(
      CompanyNotificationActionTypes.CompanyNotificationsPageRequested,
    ),
    mergeMap(({ payload }) => {
      this.store.dispatch(this.showPageLoadingDispatcher);
      const requestToServer = this.companyNotificationsService.getCompanyNotifications(
        payload.page,
      );
      const lastQuery = of(payload.page);
      return forkJoin([requestToServer, lastQuery]).pipe(
        catchError((error) => {
          return of([error]);
        }),
        map((response) => {
          if (response[0].error) {
            if (response[0].status === 401) {
              return response[0];
            } else if (response[0].status === 403) {
              this.router.navigateByUrl('/error/403');
              return new CompanyNotificationsPageCancelled();
            } else {
              this.store.dispatch(new ThrowCompanyNotificationError({ error: response[0].error }));
              return new CompanyNotificationsPageCancelled();
            }
          } else {
            const result = response[0];
            // tslint:disable-next-line:no-shadowed-variable
            const lastQuery: QueryParamsModel = response[1];
            return new CompanyNotificationsPageLoaded({
              companyNotifications: result.data,
              totalCount: result.count,
              page: lastQuery,
            });
          }
        }),
      );
    }),
  );

  constructor(
    private actions$: Actions,
    private companyNotificationsService: CompanyNotificationService,
    private authService: AuthService,
    private store: Store<AppState>,
    private router: Router,
  ) {}
}
